import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { Button } from "@/shared/ui";

/** Header links whose pages come in later phases (cart, promo, stores…). */
export function ComingSoonPage() {
  const { t } = useTranslation(["shop", "common"]);
  return (
    <div className="container-page flex flex-col items-center gap-4 py-24 text-center">
      <p className="text-lg text-muted">{t("shop:comingSoon")}</p>
      <Button asChild variant="secondary">
        <Link to="/">{t("common:errors.notFoundAction")}</Link>
      </Button>
    </div>
  );
}
